(function () {
  const form = document.getElementById('ctcForm');
  if (!form) return;

  const isEs = location.pathname.startsWith('/es/');
  const siteKey = window.RECAPTCHA_SITE_KEY || '';

  let recaptchaReady = null;

  function loadRecaptcha() {
    if (!siteKey) return Promise.resolve(false);
    if (recaptchaReady) return recaptchaReady;

    recaptchaReady = new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.onload = () => {
        window.grecaptcha.ready(() => resolve(true));
      };
      script.onerror = () => resolve(false);
      document.head.appendChild(script);
    });

    return recaptchaReady;
  }

  function getRecaptchaToken() {
    if (!siteKey) return Promise.resolve('');
    return loadRecaptcha().then(ready => {
      if (!ready) return '';
      return window.grecaptcha.execute(siteKey, { action: 'contact' }).catch(() => '');
    });
  }

  loadRecaptcha();

  const selectWrap = document.getElementById('ctcSubjectWrap');
  const selectBtn = document.getElementById('ctcSubjectBtn');
  const selectPanel = document.getElementById('ctcSubjectPanel');
  const subjectInput = document.getElementById('ctcSubject');
  const quoteFields = document.getElementById('ctcQuoteFields');
  const submitBtn = document.getElementById('ctcSubmit');
  const successPanel = document.getElementById('ctcSuccess');
  const fieldsWrap = document.getElementById('ctcFields');

  function clearErrors() {
    form.querySelectorAll('.ctc2-form__error').forEach(el => { el.textContent = ''; });
    form.querySelectorAll('.has-error').forEach(el => el.classList.remove('has-error'));
  }

  function setError(field, message) {
    const el = form.querySelector(`[data-error-for="${field}"]`);
    if (el) el.textContent = message;
    const input = form.querySelector(`[name="${field}"]`) || (field === 'subject' ? selectBtn : null);
    input?.closest('.ctc2-form__input, .ctc2-form__checkbox, .ctc2-form__select-wrap')?.classList.add('has-error');
    input?.classList.add('has-error');
  }

  selectBtn.addEventListener('click', () => {
    selectWrap.classList.toggle('is-open');
  });

  selectPanel.querySelectorAll('.ctc2-form__select-option').forEach(option => {
    option.addEventListener('click', () => {
      const value = option.dataset.value;
      subjectInput.value = value;
      selectBtn.querySelector('span').textContent = value;
      selectBtn.classList.remove('is-placeholder');
      selectWrap.classList.remove('is-open');
      quoteFields.hidden = value !== 'Quote';
    });
  });

  document.addEventListener('click', (e) => {
    if (!selectWrap.contains(e.target)) {
      selectWrap.classList.remove('is-open');
    }
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    clearErrors();

    const subject = subjectInput.value;
    const email = form.email.value.trim();
    const message = form.message.value.trim();
    const privacy = form.privacy.checked;
    const budget = form.budget ? form.budget.value.trim() : '';
    const timeline = form.timeline ? form.timeline.value.trim() : '';

    let valid = true;

    if (!subject) { setError('subject', 'Please select a subject.'); valid = false; }
    if (subject === 'Quote') {
      if (!budget) { setError('budget', 'Please tell us your budget.'); valid = false; }
      if (!timeline) { setError('timeline', 'Please tell us your timing.'); valid = false; }
    }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setError('email', 'Please enter a valid email.'); valid = false; }
    if (!message) { setError('message', 'Please write a message.'); valid = false; }
    if (!privacy) { setError('privacy', 'You must accept the privacy policy.'); valid = false; }

    if (!valid) return;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending...';

    getRecaptchaToken().then(recaptcha_token => {
      const payload = { subject, budget, timeline, email, message, privacy, recaptcha_token };

      return fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
    })
      .then(r => {
        if (!r.ok) return r.json().then(body => { throw new Error(body.error || 'request_failed'); });
        return r.json();
      })
      .then(() => {
        fieldsWrap.hidden = true;
        successPanel.hidden = false;
      })
      .catch((err) => {
        const message = err.message === 'recaptcha_failed'
          ? (isEs ? 'No hemos podido verificar que no eres un robot. Inténtalo de nuevo.' : 'We could not verify you are not a robot. Please try again.')
          : (isEs ? 'Algo ha ido mal. Inténtalo de nuevo.' : 'Something went wrong. Please try again.');
        setError('message', message);
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send';
      });
  });
})();
